export const floatingToolbarClassName =
	'absolute bottom-0 left-0 right-0 flex items-center p-3 gap-2 rounded-lg bg-white md:gap-4 justify-end'
